export const track = (module, action, props) => {
  if (window.TL && window.TL.Track) {
    return window.TL.Track.track(module, action, props);
  }
};
